import * as z from 'zod';
import { ErrorMessages } from './error-messages';

export const ticketPurchaseFormSchema = z.object({
  ticketTypes: z.array(
    z.object({
      tickets: z.array(
        z.object({
          firstName: z.string().min(1, ErrorMessages.Required),
          lastName: z.string().min(1, ErrorMessages.Required),
          email: z
            .string()
            .email(ErrorMessages.Email.INVALID)
            .min(1, ErrorMessages.Required),
          timeSlotIndex: z.number().optional(),
        }),
      ),
    }),
  ),
});

export type TicketPurchaseForm = z.TypeOf<typeof ticketPurchaseFormSchema>;
